import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Apollo, QueryRef } from 'apollo-angular';
import gql from 'graphql-tag';
import { Subject } from 'rxjs';
import { SessionVariables } from '../constants';
import {GcsCloudwatchService} from './gcs-cloudwatch.service'
import { AwsStsGetTempCredentialsService } from './aws-sts-get-temp-credentials.service';

@Injectable({
  providedIn: 'root'
})
export class DynamicComponentCreateService {
  debugger

  private tempCredentials :any;
  public rootViewContainer: any;
  public allSortableItems: any;
  private getRearrangeViewDefaultQuery: QueryRef<any>;
  public allOpenCases = [];
  public allOpenCasesHome = [];
  public myOpenCases = [];
  public myOpenCasesHome = [];
  public setDefaultData: any = {
    allRearrangeServices: []
  };
  private dataSource = new BehaviorSubject(this.setDefaultData);
  public sharingData = this.dataSource.asObservable();

  public loginData = new BehaviorSubject(false);
  public companyOverview = new BehaviorSubject(false);
  public headerNavChips = new BehaviorSubject(false);
  public reArrangeViewData = new BehaviorSubject(false);
  public myCompanyChips = new BehaviorSubject(false);
  public allSubMenus = new BehaviorSubject(false);
  public myCompanyHomeComponentBehaviourSubj = new BehaviorSubject(false);
  public gcsUsersGrid = new BehaviorSubject(false);
  public remoteServicesGrid = new BehaviorSubject(false);
  public gcsSitesGrid = new BehaviorSubject(false);
  public myCompanySubMenu = new BehaviorSubject(false);
  public getproductFamilyservice = new BehaviorSubject(false);
  public getquicklinkservice = new BehaviorSubject(false);
  public getvideoslinksservice = new BehaviorSubject(false);
  public getquicklinksettingservice = new BehaviorSubject(false);

  public IdmsInfo = new BehaviorSubject(false);
  public caseFilters = new BehaviorSubject(false);
  public caseList = new BehaviorSubject(false);
  public notificationAndAlerts = new Subject();
  public allNotificationAndAlerts = new Subject();
  public overView = new BehaviorSubject(false);
  public overViewUser = new BehaviorSubject(false);
  public customerEmail = new BehaviorSubject(false);
  public customerLocation = new BehaviorSubject(false);
  public stateLocation = new BehaviorSubject(false);
  public customerProductFamily = new BehaviorSubject(false);
  public regionalGcsInfo = new BehaviorSubject(false);
  public customerRegistrationSubmit = new BehaviorSubject(false);
  public compHomeChipColor = new BehaviorSubject(false);
  public casesHomeChipsNavigation = new BehaviorSubject(false);
  public getCaseTypes = new BehaviorSubject(false);
  public getFileExtentions = new BehaviorSubject(false);
  public getPriorities = new BehaviorSubject(false);
  public getCompanies = new BehaviorSubject(false);
  public getSites = new BehaviorSubject(false);
  public getContacts = new BehaviorSubject(false);
  public genCaseTypeSubmitCase = new BehaviorSubject(false);
  public getCaseTypeSubscription = new BehaviorSubject(false);
  public genAddCaseSubscription = new BehaviorSubject(false);
  public genCaseTypeSummaryCase = new BehaviorSubject(false);
  public getProductFamilies = new BehaviorSubject(false);
  public getProductFamiliesForParts = new BehaviorSubject(false);
  public getProductGroups = new BehaviorSubject(false);
  public getProduct = new BehaviorSubject(false);
  public getProductVersion = new BehaviorSubject(false);
  public getRequestInfo = new BehaviorSubject(false);
  public createCaseChipSelect = new BehaviorSubject(false);
  public getRequestTypeValues = new BehaviorSubject(false);
  public getContractTypeValues = new BehaviorSubject(false);
  public getPartValues = new BehaviorSubject([]);
  public getShipTo = new BehaviorSubject(false);
  public getBillTo = new BehaviorSubject(false);
  public profileEditFormSubmit = new Subject();
  public getFailureTypeValues = new BehaviorSubject(false);
  public getTECPERInfo = new BehaviorSubject(false);
  public genDeleteCaseSubscription = new BehaviorSubject(false);
  public prevStep = new BehaviorSubject(false);
  public isNavDialogOpen = new BehaviorSubject(false);
  public uploadedFilesGEN = new BehaviorSubject([]);
  public genGetUploadList = new Subject<any>()
  public uploadedFilesObs = new BehaviorSubject([]);
  public tecPerRequestCaseClosure = new BehaviorSubject(false);
  public PERuploadedFilesObs = new BehaviorSubject([]);
  public tecPerCaseTypeSubmitCase = new BehaviorSubject(false);
  public getFileTo = new BehaviorSubject(false);
  public getUploadTo = new BehaviorSubject(false);
  public getDownloadTo = new BehaviorSubject(false);

  public getGCSDownloadTo = new BehaviorSubject(false);
  public tecPerGetComments = new BehaviorSubject(false);
  public tecCaseTypeSummaryCase = new BehaviorSubject(false);
  public perCaseTypeSummaryCase = new BehaviorSubject(false);
  public getTECPERCommentInfo = new BehaviorSubject(false);
  public getTECPERCommentAdd = new BehaviorSubject(false);
  public tecPerCaseFileupload = new BehaviorSubject(false);
  public genCaseFileupload = new Subject<any>();
  public mepCaseTypeSummaryCase = new BehaviorSubject(false);
  public mepCaseOrderStatus = new BehaviorSubject(false);
  public userNameChanged$ = new Subject();
  public getFieldServiceType = new BehaviorSubject(false);
  public getFieldServiceOss = new BehaviorSubject(false);
  public getFieldServiceOssTraining = new BehaviorSubject(false);
  public getFieldServiceOssLocation = new BehaviorSubject(false);
  public getFieldServiceOssCourse = new BehaviorSubject(false);
  public mepSubmitCase = new BehaviorSubject(false);
  public caseStatus = new BehaviorSubject(false);
  public caseTypes = new BehaviorSubject(false);
  public companyDropDownList = new BehaviorSubject(false);
  public getFieldEngineeringServiceOss = new BehaviorSubject(false);
  public ossSubmitCase = new BehaviorSubject(false);
  public ossCaseTypeSummaryCase = new BehaviorSubject(false);
  public checktotalCountCaseList = new BehaviorSubject(false);
  public caseListAllOpenCases = new BehaviorSubject(false);
  public checktotalCountCaseListAllCases = new BehaviorSubject(false);
  public naviagetBackToCreateCase = new BehaviorSubject(false);
  public naviagetBackToConfirmCase = new BehaviorSubject(false);
  public bellNotificationAndAlerts = new BehaviorSubject(false);
  public updateBellNotificationAndAlerts = new BehaviorSubject(false);
  public getCustomerSiteInfo = new BehaviorSubject(false);
  public getSiteEquipmentDetails = new BehaviorSubject(false);
  public getRemoteServicesEmails = new BehaviorSubject(false);
  public getSiteDetails = new BehaviorSubject(false);
  public getPartSearchDetails = new BehaviorSubject(false);
  public getSAV = new BehaviorSubject(false);
  public getRemoteServicesTopStations = new BehaviorSubject(false);
  public getRemoteServicesTopMessages = new BehaviorSubject(false);
  public getRemoteServicesEventMessages = new BehaviorSubject(false);
  public getMessageInfo = new BehaviorSubject(false);
  public getIndustryTypes = new BehaviorSubject(false);
  public getProductVersions = new BehaviorSubject(false);
  public getAppType = new BehaviorSubject(false);
  public getDCS = new BehaviorSubject(false);

  public getBannerMessage = new BehaviorSubject(false);
  public updateProfileInfo = new BehaviorSubject(false);
  public errorOverview = new BehaviorSubject(false);
  public errorCaseList = new BehaviorSubject(false);
  public caseManagementSelection = new BehaviorSubject(false);
  public errorLogHandling =   new Subject<any>();
  public SupportMegaMenu= new Subject<any>();
  public SoftwareMegaMenu= new Subject<any>();
  public DocumentMegaMenu= new Subject<any>();
  public blockedEmailDomains= new Subject<any>();
  public getSTSTempCredentials = new Subject<any>();
  public bfoCasesDataSession: any;
  public  mepGetPartSubjets = new Subject<[]>();
  public  mepGetOrderSubjets = new Subject<[]>();


  public sessionData: any = {"data":{"getLoggedInUserInfo":{"__typename":"loggedInUserDetailsSecureOutput","CFID":"0000124438","CFIDList":"0000124438,0000127439,0000127441,0000143465","Isparentaccess":1,"JWT":"","JWTRefreshToken":"","accessToken":"","accountId":"001A0000016L11sIAC","ail":"(Application;GCSWeb),(Program;GCS_Contract)","ailApplications":"GCSWeb","ailPrograms":"GCS_Contract","annualRevenue":"0","apigeeAccessToken":"","bFOAccountID":"001A0000016L11sIAC","bFOContactID":"0037800000NjT8zAAF","classLevel1":"EU","companyCity":null,"companyCountryCode":"US","companyFederationId":"gb007599-b75e-2260-95f1-ef74c012fea2","companyName":"DCP Midstream (Falfurrias, TX) ","companyStateOrProvinceCode":null,"companyStreet":null,"companyZipCode":null,"company_code":240,"contactGoldenID":null,"contactId":"0037800000NjT8zAAF","cookieEnabled":0,"countryCode":216,"countryDesc":"USA","countryIsoCode":"US","currency":"EUR","customer_code":3196,"email":"steven.dcp@yopmail.com","emailOptIn":"N","enabled":null,"fedratedSearchToken":"","firstName":"Stephen","gcsWebAccess":1,"headquarter":false,"identityType":"Email","isAILSet":true,"isEmailMatched":true,"isInternal":"FALSE","languageCode":"EN","lastName":"DCP","level_code":2,"marketSegment":null,"middleName":null,"parentCompany":"DCP Midstream","region":"North America","regionCode":1,"stateCode":54,"trustLevel":"IsTrustedAdmin","userAddress":"","userCity":"iowa","userContext":"Work","userCountry":"US","userCountryCode":216,"userCountryDesc":"USA","userCountryIsoCode":"US","userEntitlement":"CustomerFIRST","userGroup":2,"userId":"00578000002GnNkAAK","userName":"Stephen DCP","userPhone":"","userPostalCode":"122228","userRegionCode":1,"userRegionDesc":"North America","userState":"AZ","userStateCode":54,"userStateName":"Texas","user_code":84524,"workPhone":null,"bfoApiUrl":null,"bfoErrorMsg":null,"bfoStatusCode":null,"idmsRefreshAccessToken":"","bfoApiPayload":null,"UserGroupList":"113,164,168,171","federatedId":"gb007599-b75e-2260-95f1-ef74c012fea2"}}};

  constructor(private apollo: Apollo,private cloudwatchlog :GcsCloudwatchService,private awssts: AwsStsGetTempCredentialsService) {
    console.log("DynamicComponentCreateService")

    // setInterval( async ()=>{await this.getTempCredentials()
    //   console.log("getTempCredentials")
    //  },1000)

    }

  public storeDevUserData(): void {
    sessionStorage.setItem(SessionVariables.loggedInUserDetails, JSON.stringify(this.sessionData));
    sessionStorage.setItem(SessionVariables.isLoggedIn, '1');
    sessionStorage.setItem(SessionVariables.sessionToken, this.sessionData.data.getLoggedInUserInfo.JWT);


  }

  public setSortableItems(items: any): void {
    this.setDefaultData.allRearrangeServices = items || [];
    this.dataSource.next(this.setDefaultData);
  }

  public getSortableItems(): any[] {
    return this.allSortableItems || [];
  }

  public checkDefaultView(view: boolean): void {
    this.setDefaultData.checkIsDefaultView = view;
    this.dataSource.next(this.setDefaultData);
  }

  public getChipIcon(chipName): string {
    let icon: string;
    switch (chipName) {
      case 'Case Overview':
        icon = 'dashboard';
        break;
      case 'Case List':
        icon = 'box2';
        break;
      case 'Case Statictics':
        icon = 'product_selector';
        break;
      case 'Company Overview':
        icon = 'action_datasheet';
        break;
      case 'Notifications & Alerts':
        icon = 'building_flat';
        break;
      case 'Product & Documentation':
        icon = 'building_flat';
        break;
      case 'Software & Updates':
        icon = 'product_selector';
        break;
      case 'InstalledBase':
        icon = 'building_flat';
        break;
      case 'Remote Services':
        icon = 'building_flat';
        break;
      case 'Company Home':
        icon = 'action_datasheet';
        break;
      case 'GCS Users':
        icon = 'product_selector';
        break;
      case 'Sites':
        icon = 'dashboard';
        break;
      case 'Cases Home':
        icon = 'box2';
        break;
      case 'Create Case':
        icon = 'action_editor';
        break;
      case 'Case Statistics':
        icon = 'graph_barchart';
        break;
      case 'About Case Type':
        icon = 'information_stroke';
        break;
      case 'About Case Status':
        icon = 'information_stroke';
        break;
    }
    return icon;
  }

  public setSavedOrderElements(elements: any[]): void {
    this.allSortableItems = elements;
  }
  public getSavedOrderElements(): any[] {
    return this.allSortableItems || [];
  }

  // get the rearrange view fo default if we don't have any Fedrated ID
  public getRearrangeViewDefaultFun(): void {
    this.getRearrangeViewDefaultQuery = this.apollo.watchQuery({
      query: gql`
      query{
        getRearrangeView(id:"default"){
          id
          services{
            servicename
            show
            order
          }
        }
      }`,
    });
    this.getRearrangeViewDefaultQuery.valueChanges.subscribe((result) => {
      if (result) {
        const data = result.data || {};
        const getOrderList = (data.getRearrangeView && data.getRearrangeView.services) || [];
        this.setSortableItems(getOrderList);
        const defaultFlag = true;
        this.checkDefaultView(defaultFlag);
      }
    });
  }

  // get Fadrated id and header menu id from session storage
  public getIds(idType?: string): any {
    const userLoginSessionData = JSON.parse(sessionStorage.getItem(SessionVariables.loggedInUserDetails));
    const userLoggedInInfoData = userLoginSessionData && userLoginSessionData.data;
    const getLoggedInUserInfo = userLoggedInInfoData.getLoggedInUserInfo;
    if (idType === 'federatedId') {
      return getLoggedInUserInfo.idmsFederatedId;
    } else if (idType === 'menuId') {
      return `${getLoggedInUserInfo.userGroup}-${getLoggedInUserInfo.level_code}`;
    } else if (idType === 'user_code') {
      return getLoggedInUserInfo.user_code;
    } else if (idType === 'userId') {
      return getLoggedInUserInfo.userId;
    }else if (idType === 'bFOContactID') {
      return getLoggedInUserInfo.bFOContactID;
    } else if (idType === 'level_code') {
      return getLoggedInUserInfo.level_code;
    } else if (idType === 'accessToken') {
      return getLoggedInUserInfo.accessToken;
    } else if (idType === 'bFOAccountID') {
      return getLoggedInUserInfo.bFOAccountID;
    } else if (idType === 'userGroup') {
      return getLoggedInUserInfo.userGroup;
    } else if (idType === 'region') {
      return getLoggedInUserInfo.userRegionDesc;
    } else if (idType === 'Isparentaccess') {
      return getLoggedInUserInfo.Isparentaccess;
    } else if (idType === 'isAILSet') {
      return getLoggedInUserInfo.isAILSet;
    }else if (idType === 'UserGroupList') {
      return getLoggedInUserInfo.UserGroupList;
    }
    else if (idType === 'federatedId') {
      return getLoggedInUserInfo.federatedId;
    }
    else if (idType === 'companyName') {
      return getLoggedInUserInfo.companyName;
    }
    else if (idType === 'company_code') {
      return getLoggedInUserInfo.company_code;
    }
    else if (idType === 'username') {
      return getLoggedInUserInfo.userName
    }
    else if (idType === 'useremail') {
      return getLoggedInUserInfo.email
    }
    else if (idType === 'userPhone') {
      return getLoggedInUserInfo.userPhone
    }
    else if (idType === 'customer_code') {
      return getLoggedInUserInfo.customer_code
    }

    else {
      return getLoggedInUserInfo;
    }
  }

  public navigateCreateCasewithSessionClear(): void {
    sessionStorage.removeItem(SessionVariables.createCaseFirstForm);
    sessionStorage.removeItem(SessionVariables.createCaseGenForm);
    sessionStorage.removeItem(SessionVariables.selectedCaseType);
    sessionStorage.removeItem(SessionVariables.selectedCompany);
    sessionStorage.removeItem(SessionVariables.selectedPriority);
    sessionStorage.removeItem(SessionVariables.selectedSite);
    sessionStorage.removeItem(SessionVariables.selectedProductFamily);
    sessionStorage.removeItem(SessionVariables.selectedProductGroup);
    sessionStorage.removeItem(SessionVariables.selectedProducts);
    sessionStorage.removeItem(SessionVariables.selectedProductVersion);
    sessionStorage.removeItem(SessionVariables.selectedArea);
    sessionStorage.removeItem(SessionVariables.selectedReprod);
    sessionStorage.removeItem(SessionVariables.mepProductRequestInfo);
    sessionStorage.removeItem(SessionVariables.mepPartsGridData);
    // sessionStorage.removeItem(SessionVariables.mepFailureTypeValues);
    sessionStorage.removeItem(SessionVariables.mepRequestTypeValues);
    sessionStorage.removeItem(SessionVariables.genSummaryCaseData);
    sessionStorage.removeItem(SessionVariables.getCaseTypeSubscription);
    sessionStorage.removeItem(SessionVariables.genSubmitCaseData);
    sessionStorage.removeItem(SessionVariables.homeCaseNumber);
    sessionStorage.removeItem(SessionVariables.homeCaseType);
    sessionStorage.removeItem(SessionVariables.homeUseCode);
    this.getCaseTypeSubscription.next(false);
    this.genCaseTypeSummaryCase.next(false);
    sessionStorage.removeItem(SessionVariables.mepShippingBillingDetails);
    sessionStorage.removeItem(SessionVariables.mepContaminationInfoDetails);
    sessionStorage.removeItem(SessionVariables.mepProductDataConfirm);
    sessionStorage.removeItem(SessionVariables.mepShippingBillingConfirm);

    sessionStorage.removeItem(SessionVariables.selectedArea);
    sessionStorage.removeItem(SessionVariables.selectedReprod);

    // get session MEP case type details
    sessionStorage.removeItem(SessionVariables.mepProductDataConfirm);
    sessionStorage.removeItem(SessionVariables.mepPartsGridData);
    sessionStorage.removeItem(SessionVariables.mepShippingBillingConfirm);
    sessionStorage.removeItem(SessionVariables.mepContaminationInfoDetails);

    sessionStorage.removeItem(SessionVariables.PERdescription);
    sessionStorage.removeItem(SessionVariables.PERsuggestedSolution);
    sessionStorage.removeItem(SessionVariables.PERsubjectProductForm);
    sessionStorage.removeItem(SessionVariables.PERanticipatedBenefits);
    sessionStorage.removeItem(SessionVariables.TECdescription);
    sessionStorage.removeItem(SessionVariables.selectedProducts);
    //sessionStorage.removeItem(SessionVariables.getTECPERData);

    // get session TEC case type details
    sessionStorage.removeItem(SessionVariables.TECsubjectProductForm);

    // Oss session clear
    sessionStorage.removeItem(SessionVariables.ossPartsGridData);
this.getFailureTypeValues.next(false);
    this.uploadedFilesObs.next([]);
    this.PERuploadedFilesObs.next([]);
    sessionStorage.removeItem(SessionVariables.mepPartsGridData);
    this.tecPerCaseTypeSubmitCase.next(false);
    this.genCaseTypeSubmitCase.next(false);
    this.tecCaseTypeSummaryCase.next(false);
    this.perCaseTypeSummaryCase.next(false);
    sessionStorage.removeItem(SessionVariables.selectedCommercialReference);
    this.mepSubmitCase.next(false);
    sessionStorage.removeItem(SessionVariables.mepSummaryCaseData);
    sessionStorage.removeItem(SessionVariables.mepSubmitCaseData);
    // clear OSS case type session
    // this.tecPerCaseTypeSubmitCase.next(false);
    this.ossSubmitCase.next(false);
    sessionStorage.removeItem(SessionVariables.tecSummaryCaseData);
    sessionStorage.removeItem(SessionVariables.perSummaryCaseData);
    sessionStorage.removeItem(SessionVariables.ossSummaryCaseData);

    sessionStorage.removeItem(SessionVariables.ossProductRequestInfo);
    sessionStorage.removeItem(SessionVariables.ossPreventiveMaintenanceInfo);
    sessionStorage.removeItem(SessionVariables.ossSystemUpgradeServicesInfo);
    sessionStorage.removeItem(SessionVariables.ossSubmitCaseData);

    this.uploadedFilesGEN.next([])
  }

  // store all Open Cases
  public sessionAllOpenCases(openCases: any): any {
    this.allOpenCases = openCases;
  }
  public getSessionAllOpenCases(): any {
    return this.allOpenCases || [];
  }

  public sessionAllOpenCasesHome(openCases: any): any {
    this.allOpenCasesHome = openCases;
  }
  public getSessionAllOpenCasesHome(): any {
    return this.allOpenCasesHome || [];
  }

  // store my Open Cases
  public sessionmyOpenCases(openCases: any): any {
    this.myOpenCases = openCases;
  }
  public getSessionmyOpenCases(): any {
    return this.myOpenCases || [];
  }

  public sessionmyOpenCasesHome(openCases: any): any {
    this.myOpenCasesHome = openCases;
  }
  public getSessionmyOpenCasesHome(): any {
    return this.myOpenCasesHome || [];
  }

  // cache the bfo cases
  public bfoCasesSession(bfoData: any): void{
    this.bfoCasesDataSession = bfoData || [];
  }
  public getBfoDataSession(): any{
    return this.bfoCasesDataSession || [];
  }


  public escape = function (str) {
    return str
      .replace(/[\\]/g, '\\\\')
      .replace(/[\"]/g, '\\"')

      .replace(/[\/]/g, '\\/')
      .replace(/[\b]/g, '\\b')
      .replace(/[\f]/g, '\\f')
      .replace(/[\n]/g, '\\n')
      .replace(/[\r]/g, '\\r')
      .replace(/[\t]/g, '\\t')
      ;
   };

   public escapeSpecialCharacters = function (str: string): string {
    if (!str) return ""; 
    return str
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
   }


   public async  WritelogToCloudWatch(...args)
   {/*
   // console.log(args)
  var cred =await this.getTempCredentials()
  //console.log(cred)

   var  logToWrite =JSON.stringify(args.concat())
      this.cloudwatchlog.writeLog(logToWrite,this.getIds('user_code'), cred)

      // console.log(logToWrite)*/
   }

public async getTempCredentials()
{
  console.log("getTempCredentials")
  debugger

  if(this.tempCredentials && this.tempCredentials.Expiration && this.tempCredentials.Expiration > new Date().toISOString() )
  {

    console.log("resure credentials ")
    return this.tempCredentials

  }

  else
  {
    console.log("get new cred")
    return await this.getTempCredentialsFromAWS()
  }
}
   public async  getTempCredentialsFromAWS()
   {
    try {
      var credentials =await this.awssts.getSTSTempCredentials()

      this.getSTSTempCredentials.next(credentials)

      //var currentTime = new Date();
     // currentTime.setDate(currentTime.getHours()+1);
     // credentials.ExpireDate =currentTime
      this.tempCredentials = credentials.AssumeRoleForTempCredentials;
      return credentials.AssumeRoleForTempCredentials

    } catch (error) {
      console.log(error);

    }

   }

   public getAllExtensions(arg0: any):any{
    let all =[];
    arg0.forEach(element => {
      // console.log(element);
      all.push(element.Extension);
    });;
    return all;
  }
}

export  enum LogType{
  info,
  error

}

